export default "__VITE_ASSET__93c16929__"